import React from 'react'

function TabPanel({ children }) {
  return (
    <>{children}</>
  )
}

export default TabPanel